import QuestionMark from "./images/questionmark.svg";
import GirlFaceSuccess from "./images/girl-face-success.svg";
import GirlHand from "./images/girl-hand.svg";
import GirlThumbTwiches from "./images/girl-thumb-twiches.svg";
import GirlThumb from "./images/girl-thumb.svg";
import Girl from "./images/girl.svg";
import Loader from "./images/loader.svg";
import DataSourcesNoResults from "./images/DataSourcesNoResults.svg";
import AddAutomationEmpty from "./images/add-automation-empty.svg";
import DashedArrowActive from "./images/dashed-arrow-active.svg";
import DashedArrowActiveDark from "./images/dashed-arrow-active-dark.svg";
import DashedArrow from "./images/dashed-arrow.svg";
import DashedArrowDark from "./images/dashed-arrow-dark.svg";
import EmptyStateImg from "./images/empty-state-img.svg";
import LoginBg from "./images/login-bg.svg";
import IconAi from "./images/icon-ai.svg";
import NoProfiles from "./images/no-profiles.svg";
import WorkflowsBgPattern from "./images/workflows_bg_pattern.svg";
import WorkflowsBgPatternDark from "./images/workflows_bg_pattern-dark.svg";
import SeemaSuccess from "./images/seema-success.svg";
import SeemMagic from "./images/seem-magic.svg";
import ScopesTreeSimulation from "./images/scopes-tree-simulation.svg";
import RadialGradient from "./images/radialgradient.svg";
import NotificationsEmptyStatePhoto from "./images/notifications-empty-state.svg";
import TicketingEmptyStatePhoto from "./images/ticketing-empty-state.svg";
import AddAutomationEmptyDark from "./images/add-automation-empty-dark.svg";
import EmptyStateImgDark from "./images/empty-state-img-dark.svg";
import NoProfilesDark from "./images/no-profiles-dark.svg";
import SeemMagicDark from "./images/seem-magic-dark.svg";
import ScopesTreeSimulationDark from "./images/scopes-tree-simulation-dark.svg";
import IconAiWhite from "./images/icon-ai-white.svg";
import ExampleWidget from "./images/example-widget.svg";
import ExampleWidgetDark from "./images/example-widget-dark.svg";
import FileIcon from "./images/file-icon.svg";
import FileIconDark from "./images/file-icon-dark.svg";
import IconZip from "./images/icon-zip.svg";
import IconZipDark from "./images/icon-zip-dark.svg";
import IconXls from "./images/icon-xls.svg";
import IconXlsDark from "./images/icon-xls-dark.svg";
import IconXlsx from "./images/icon-xlsx.svg";
import IconXlsxDark from "./images/icon-xlsx-dark.svg";
import IconPptx from "./images/icon-pptx.svg";
import IconPptxDark from "./images/icon-pptx-dark.svg";
import IconRar from "./images/icon-rar.svg";
import IconRarDark from "./images/icon-rar-dark.svg";
import IconTxt from "./images/icon-txt.svg";
import IconTxtDark from "./images/icon-txt-dark.svg";
import IconPdf from "./images/icon-pdf.svg";
import IconPdfDark from "./images/icon-pdf-dark.svg";
import IconPng from "./images/icon-png.svg";
import IconPngDark from "./images/icon-png-dark.svg";
import IconPpt from "./images/icon-ppt.svg";
import IconPptDark from "./images/icon-ppt-dark.svg";
import IconHtml from "./images/icon-html.svg";
import IconHtmlDark from "./images/icon-html-dark.svg";
import IconJpg from "./images/icon-jpg.svg";
import IconJpgDark from "./images/icon-jpg-dark.svg";
import IconJson from "./images/icon-json.svg";
import IconJsonDark from "./images/icon-json-dark.svg";
import IconDocx from "./images/icon-docx.svg";
import IconDocxDark from "./images/icon-docx-dark.svg";
import IconDoc from "./images/icon-doc.svg";
import IconDocDark from "./images/icon-doc-dark.svg";
import IconCsv from "./images/icon-csv.svg";
import LogoColor from "./logos/logo-color.svg";
import LogoWhite from "./logos/logo-white.svg";
import SeemplicityColored from "./images/seemplicity-colored.svg";
import SeemplicityColoredDark from "./images/seemplicity-colored-dark.svg";
import IconCsvDark from "./images/icon-csv-dark.svg";
import IconCss from "./images/icon-css.svg";
import IconCssDark from "./images/icon-css-dark.svg";
import IconClose from "./images/icon-close.svg";
import IconCloseDark from "./images/icon-close-dark.svg";
import IconNotebook from "./images/icon-notebook.svg";
import IconAiFillActive from "./images/icon-ai-fill-active.svg";
import IconAiFill from "./images/icon-ai-fill.svg";
import IconAiOutline from "./images/icon-ai-outline.svg";
import SeemaAI from "./images/seema-ai.svg";
import AnalyzeAI from "./images/analyze-ai.svg";
import AnalyzeAIDark from "./images/analyze-ai-dark.svg";
import Analyze from "./images/analyze.svg";
import AnalyzeDark from "./images/analyze-dark.svg";
import SastAnalyst from "./images/sast-analyst.svg";
import ScaAnalyst from "./images/sca-analyst.svg";
import HostVmAnalyst from "./images/host-vm-analyst.svg";
import WebAnalyst from "./images/web-analyst.svg";
import ContainerAnalyst from "./images/container-analyst.svg";
import IconPending from "./images/icon-pending.svg";
import IconPendingDark from "./images/icon-pending-dark.svg";
import NoPackages from "./images/no-packages.svg";
import NoPackagesDark from "./images/no-packages-dark.svg";

export const DefaultAppIcons: Record<
  string,
  { LIGHT: string; DARK: string | null }
> = {
  questionmark: {
    LIGHT: QuestionMark,
    DARK: null,
  },
  girl_face_success: {
    LIGHT: GirlFaceSuccess,
    DARK: null,
  },
  girl_hand: {
    LIGHT: GirlHand,
    DARK: null,
  },
  girl_thumb_twiches: {
    LIGHT: GirlThumbTwiches,
    DARK: null,
  },
  girl_thumb: {
    LIGHT: GirlThumb,
    DARK: null,
  },
  girl: {
    LIGHT: Girl,
    DARK: null,
  },
  "seema-ai": {
    LIGHT: SeemaAI,
    DARK: null,
  },
  "icon-spinner": {
    LIGHT: Loader,
    DARK: null,
  },
  DataSourcesNoResults: {
    LIGHT: DataSourcesNoResults,
    DARK: null,
  },
  "add-automation-empty": {
    LIGHT: AddAutomationEmpty,
    DARK: AddAutomationEmptyDark,
  },
  "dashed-arrow-active": {
    LIGHT: DashedArrowActive,
    DARK: DashedArrowActiveDark,
  },
  "dashed-arrow": {
    LIGHT: DashedArrow,
    DARK: DashedArrowDark,
  },
  "empty-state-img": {
    LIGHT: EmptyStateImg,
    DARK: EmptyStateImgDark,
  },
  "login-bg": {
    LIGHT: LoginBg,
    DARK: null,
  },
  "icon-ai": {
    LIGHT: IconAi,
    DARK: null,
  },
  "no-profiles": {
    LIGHT: NoProfiles,
    DARK: NoProfilesDark,
  },
  workflows_bg_pattern: {
    LIGHT: WorkflowsBgPattern,
    DARK: WorkflowsBgPatternDark,
  },
  "seema-success": {
    LIGHT: SeemaSuccess,
    DARK: null,
  },
  "seem-magic": {
    LIGHT: SeemMagic,
    DARK: SeemMagicDark,
  },
  "scopes-tree-simulation": {
    LIGHT: ScopesTreeSimulation,
    DARK: ScopesTreeSimulationDark,
  },
  radialgradient: {
    LIGHT: RadialGradient,
    DARK: null,
  },
  "notifications-empty-state": {
    LIGHT: NotificationsEmptyStatePhoto,
    DARK: null,
  },
  "ticketing-empty-state": {
    LIGHT: TicketingEmptyStatePhoto,
    DARK: null,
  },
  "icon-ai-white": {
    LIGHT: IconAiWhite,
    DARK: null,
  },
  "example-widget": {
    LIGHT: ExampleWidget,
    DARK: ExampleWidgetDark,
  },
  "file-icon": {
    LIGHT: FileIcon,
    DARK: FileIconDark,
  },
  "icon-zip": {
    LIGHT: IconZip,
    DARK: IconZipDark,
  },
  "icon-xls": {
    LIGHT: IconXls,
    DARK: IconXlsDark,
  },
  "icon-xlsx": {
    LIGHT: IconXlsx,
    DARK: IconXlsxDark,
  },
  "icon-pptx": {
    LIGHT: IconPptx,
    DARK: IconPptxDark,
  },
  "icon-rar": {
    LIGHT: IconRar,
    DARK: IconRarDark,
  },
  "icon-txt": {
    LIGHT: IconTxt,
    DARK: IconTxtDark,
  },
  "icon-pdf": {
    LIGHT: IconPdf,
    DARK: IconPdfDark,
  },
  "icon-png": {
    LIGHT: IconPng,
    DARK: IconPngDark,
  },
  "icon-ppt": {
    LIGHT: IconPpt,
    DARK: IconPptDark,
  },
  "icon-html": {
    LIGHT: IconHtml,
    DARK: IconHtmlDark,
  },
  "icon-jpg": {
    LIGHT: IconJpg,
    DARK: IconJpgDark,
  },
  "icon-json": {
    LIGHT: IconJson,
    DARK: IconJsonDark,
  },
  "icon-docx": {
    LIGHT: IconDocx,
    DARK: IconDocxDark,
  },
  "icon-doc": {
    LIGHT: IconDoc,
    DARK: IconDocDark,
  },
  "icon-csv": {
    LIGHT: IconCsv,
    DARK: IconCsvDark,
  },
  "icon-css": {
    LIGHT: IconCss,
    DARK: IconCssDark,
  },
  logo: {
    LIGHT: LogoColor,
    DARK: LogoWhite,
  },
  "seemplicity-colored": {
    LIGHT: SeemplicityColored,
    DARK: SeemplicityColoredDark,
  },
  "icon-ai-fill-active": {
    LIGHT: IconAiFillActive,
    DARK: IconAiFillActive,
  },
  "icon-ai-fill": {
    LIGHT: IconAiFill,
    DARK: IconAiFill,
  },
  "icon-ai-outline": {
    LIGHT: IconAiOutline,
    DARK: IconAiOutline,
  },
  "icon-close": {
    LIGHT: IconClose,
    DARK: IconCloseDark,
  },
  "icon-notebook": {
    LIGHT: IconNotebook,
    DARK: null,
  },
  "analyze-ai": {
    LIGHT: AnalyzeAI,
    DARK: AnalyzeAIDark,
  },
  "analyst-sast": {
    LIGHT: SastAnalyst,
    DARK: SastAnalyst,
  },
  "analyst-sca": {
    LIGHT: ScaAnalyst,
    DARK: ScaAnalyst,
  },
  "analyst-host-vm": {
    LIGHT: HostVmAnalyst,
    DARK: HostVmAnalyst,
  },
  "analyst-web": {
    LIGHT: WebAnalyst,
    DARK: WebAnalyst,
  },
  "analyst-container": {
    LIGHT: ContainerAnalyst,
    DARK: ContainerAnalyst,
  },
  analyze: {
    LIGHT: Analyze,
    DARK: AnalyzeDark,
  },
  "no-packages": {
    LIGHT: NoPackages,
    DARK: NoPackagesDark,
  },
  "icon-pending": {
    LIGHT: IconPending,
    DARK: IconPendingDark,
  },
};
